import schema from './schema.json';

export default {
  ...schema,

  migrate(data, fromVersion) {
    // v1 → v2: добавлены поля для годовых цен
    if (fromVersion < 2) {
      data.showPeriodToggle = data.showPeriodToggle ?? false;
      data.monthlyLabel = data.monthlyLabel ?? 'Месяц';
      data.yearlyLabel = data.yearlyLabel ?? 'Год';
      data.yearlyDiscount = data.yearlyDiscount ?? '';

      // Добавляем yearlyPrice в планы если нет
      if (data.plans) {
        data.plans = data.plans.map((plan, index) => ({
          id: plan.id || String(index + 1),
          yearlyPrice: plan.yearlyPrice ?? '',
          buttonLink: plan.buttonLink ?? '',
          ...plan
        }));
      }
    }

    // v0 → v1: базовая миграция
    if (!fromVersion || fromVersion < 1) {
      if (data.plans) {
        data.plans = data.plans.map((plan, index) => ({
          id: plan.id || String(index + 1),
          ...plan
        }));
      }
      return { ...schema.default, ...data };
    }

    return data;
  }
};
